var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TheHomeBanner'),_c('TheHomeBridesman'),_c('TheHomeArguments'),_c('TheHomeWeddings'),_c('TheHomeVideos'),_c('TheRingSeperator'),_c('TheHomeGallery'),_c('TheHomeSlogan'),_c('TheHomeContact'),_c('TheHomePodcastFab'),_c('TheHomeFbBusinessPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }